import { Routes } from '@angular/router';

import { ContentPageDetailGuard } from './guards/content-page-detail.guard';
import { ContentPageMetaGuard } from './guards/content-page-meta.guard';
import { provideState } from '@ngrx/store';
import { provideEffects } from '@ngrx/effects';

import * as fromContent from './store';

export const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: ':pageId/:target',
        loadComponent: () => import('./containers/content-page/content-page.component').then(m => m.ContentPageComponent),
        canActivate: [ContentPageDetailGuard, ContentPageMetaGuard],
        data: {
          logoClass: 'type--content',
        },
      },
      {
        path: ':slug',
        loadComponent: () => import('./containers/content-page/content-page.component').then(m => m.ContentPageComponent),
        canActivate: [ContentPageDetailGuard, ContentPageMetaGuard],
        data: {
          logoClass: 'type--content',
        },
      },
    ],
    providers: [
      provideState(fromContent.featureKey, fromContent.reducers, {
        metaReducers: fromContent.metaReducers,
      }),
      provideEffects(fromContent.effects),
    ],
  },
];
